"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _tabbable = require("tabbable");
var _buttonKit = _interopRequireDefault(require("../button-kit"));
var _focusBoomerang = _interopRequireDefault(require("../../helpers/focus-boomerang"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./confirmation-card.css");
var _excluded = ["children"],
  _excluded2 = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Wraps provided children in a styled box that supports one or two call to action buttons. This is not a modal dialog, but rather is intended to rendered inline with other content.
 */

var ConfirmationCard = function ConfirmationCard(_ref) {
  var buttonContainerClassName = _ref.buttonContainerClassName,
    _ref$caretPosition = _ref.caretPosition,
    caretPosition = _ref$caretPosition === void 0 ? 'left' : _ref$caretPosition,
    children = _ref.children,
    className = _ref.className,
    primaryCTAProps = _ref.primaryCTAProps,
    secondaryCTAProps = _ref.secondaryCTAProps,
    _ref$shouldHaveFocus = _ref.shouldHaveFocus,
    shouldHaveFocus = _ref$shouldHaveFocus === void 0 ? false : _ref$shouldHaveFocus,
    _ref$showCaret = _ref.showCaret,
    showCaret = _ref$showCaret === void 0 ? false : _ref$showCaret;
  var containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (shouldHaveFocus) {
      if (!containerRef.current) {
        return;
      }

      // Elements that can only be set focus programmatically
      var focus = new _focusBoomerang["default"]();
      var firstFocusable = containerRef.current.querySelectorAll('[tabIndex="-1"]')[0];
      var tabbableElements = (0, _tabbable.tabbable)(containerRef.current);
      var firstTabbable = tabbableElements[0];
      focus.check({
        isActive: Boolean(children),
        // Set focus to the most appropriate item
        focusedWhenActive: firstFocusable || firstTabbable || containerRef.current
      });
    }
  }, []);
  var caretStyles = (0, _classnames["default"])('sb-confirmation-card__caret', {
    'sb-confirmation-card__caretLeft': caretPosition === 'left'
  }, {
    'sb-confirmation-card__caretRight': caretPosition === 'right'
  });
  var classList = (0, _classnames["default"])('sb-confirmation-card', _defineProperty({}, caretStyles, showCaret), className);
  var _ref2 = primaryCTAProps || {},
    primaryChildren = _ref2.children,
    primaryProps = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = secondaryCTAProps || {},
    secondaryChildren = _ref3.children,
    secondaryProps = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classList,
    "data-e2e": "confirmationCard",
    ref: containerRef
  }, children, (primaryCTAProps || secondaryCTAProps) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right my2"
  }, /*#__PURE__*/_react["default"].createElement(_buttonKit["default"], {
    cancelProps: _objectSpread({}, primaryProps),
    cancelText: primaryChildren,
    className: buttonContainerClassName,
    confirmProps: _objectSpread({
      visualStyle: 'textOnly'
    }, secondaryProps),
    confirmText: secondaryChildren
  })));
};
ConfirmationCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Class applied to the container of the buttons
   */
  buttonContainerClassName: _propTypes["default"].string,
  /**
   *  If `showCaret` is true, the position of the caret. Defaults to left
   */
  caretPosition: _propTypes["default"].oneOf(['left', 'right']),
  /**
   * The content that will appear in the body of the Confirmation Card
   */
  children: _propTypes["default"].any,
  className: _propTypes["default"].string,
  /**
   * Props to pass through to a `Button`
   */
  primaryCTAProps: _propTypes["default"].object,
  /**
   * Props to pass through to a `Button`
   */
  secondaryCTAProps: _propTypes["default"].object,
  /**
   * Sets focus to the Confirmation Card when displayed
   */
  shouldHaveFocus: _propTypes["default"].bool,
  /**
   *  Shows a caret on the bottom of the Confirmation Card.
   */
  showCaret: _propTypes["default"].bool
} : {};
ConfirmationCard.displayName = 'ConfirmationCard';
var _default = exports["default"] = ConfirmationCard;